<template>
  <b-container>
    <div>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </div>

    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      :title="`#${filledId} - ${model.processName}`"
      @show="onModalShow"
      @hide="onModalHide"
    >
      <!-- Botões de ativação -->
      <b-button
        v-if="model.active == 'Sim'"
        variant="danger"
        title="Inativar card"
        class="ml-3"
        size="sm"
        :disabled="submitted"
        @click="disableProcess"
      >
        {{ $t("geral.inactivate") }}
      </b-button>
      <b-button
        v-else
        variant="green"
        title="Ativar card"
        class="ml-3"
        size="sm"
        :disabled="submitted"
        @click="activeProcess"
      >
        {{ $t("geral.activate") }}
      </b-button>

      <!-- Dados do card -->
      <process-filled
        :model.sync="model"
        :modelstate="modelstate"
        :optionsStage="options"
        :originalStatus="originalStatus"
      >
      </process-filled>

      <!-- Botões de controle-->
      <template #modal-footer="{}">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button
            class="ml-2"
            variant="danger"
            @click="$refs.openModal.hide()"
          >
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>

      <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->
    </b-modal>

    <!-- Mensagem de confirmação -->
    <base-dialog-confirm
      ref="confirm"
      @confirm="confirmHide"
      :message="'Sair sem salvar?'"
      :title="'Salvar processo'"
    >
    </base-dialog-confirm>
  </b-container>
</template>

<script>
export default {
  name: "ProcessFilledModal",
  props: {
    filledId: Number,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ProcessFilled: () =>
      import("@/components_rms/workflow/Process/ProcessFilled.vue"),
    BaseDialogConfirm: () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Processo editado com sucesso",
      },
      model: {},
      modelstate: {},
      options: [],
      isShowing: false,
      submitted: false,
      confirmModal: false,
      originalStatus: "",
    };
  },
  created() {},
  methods: {
    confirmHide() {
      this.isShowing = false;
      this.$refs.openModal.hide();
    },
    loadData() {
      this.$apiWorkflow
        .get("/processFilled/getFilled/" + this.filledId)
        .then((response) => {
          // console.log(response.data);
          this.model = response.data;
          this.oldValues = response.data.values;
          this.originalStatus = this.model.statusId;
          this.getOptions();
        });
    },
    getOptions() {
      this.$apiWorkflow
        .get("/stage/allStage/" + this.model.processId)
        .then((response) => {
          // console.log(response.data);
          this.options = response.data;
        });
    },
    refreshData() {
      // console.log('ProcessFilledModal -> refreshData()');
      this.$emit("refreshData");
    },
    save() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/fieldValue/save/", this.model)
        .then((response) => {
          this.submitted = false;
          this.isShowing = false;
          this.refreshData();
          this.hideModal();
          // this.$refs.openModal.hide();
        })
        .catch((error) => {
          this.submitted = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data) {
                if (error.response.data.errorMessage) {
                  this.modelstate = {};
                  this.alert.error = `${error.response.data.errorMessage}`;
                  this.$refs.danger.show();
                } else {
                  if (error.response.status == 400) {
                    if (error.response.data.errors) {
                      this.alert.error = "Verifique os valores informados";
                      this.modelstate = error.response.data.errors;
                      // console.log(this.modelstate);
                      // console.log(Object.values(this.modelstate)[0][0]);
                      // for (let erroModelState of Object.values(
                      //   this.modelstate
                      // )) {
                      //   console.log(erroModelState[0]);
                      //   // console.log(Object.values(erroModelState)[0])
                      //   this.alert.error += `${erroModelState[0]}`;
                      // }
                    } else {
                      this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                      this.modelstate = error.response.data.errors;
                    }
                    this.$refs.danger.show();
                  } else {
                    this.modelstate = {};
                    this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                    this.$refs.danger.show();
                  }
                }
              } else {
                this.modelstate = {};
                this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
                this.$refs.danger.show();
              }
            } else {
              this.modelstate = {};
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
            // if (error.response) {
            //   if (error.response.status == 400) {
            //     console.log(error.response.data);
            //     this.modelstate = error.response.data.errors;
            //   }
            // }
            // this.alert.error = error.message;
            // this.$refs.danger.show();
          }
          this.submitted = false;
        });
    },
    show() {
      this.model = {};
      this.modelstate = {};
      this.$refs.openModal.show();
      this.loadData();
      // this.getOptions();
    },
    hideModal() {
      this.$refs.openModal.hide();
    },
    openModal() {
      this.$refs.openModal.show();
    },
    onModalHide(bvModalEvent) {
      let showConfirmationModal = false;
      if (this.isShowing) {
        let totalFields = this.model.values.length;
        for (let i = 0; i < totalFields; i++) {
          if (this.model.values[i].value != this.model.values[i].oldValue) {
            showConfirmationModal = true;
            break;
          }
        }
      }
      // let showConfirmationModal = this.isShowing;
      if (showConfirmationModal) {
        this.$refs.confirm.show();
        bvModalEvent.preventDefault();
      } else {
        this.hideModal();
      }
    },
    onModalShow() {
      this.isShowing = true;
    },
    disableProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/processFilled/disable/" + this.filledId)
        .then((response) => {
          this.submitted = false;
          this.model.active = "Não";
          this.isShowing = false;
          this.refreshData();
          this.hideModal();
          this.$forceUpdate;
        });
    },
    activeProcess() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/processFilled/active/" + this.filledId)
        .then((response) => {
          this.submitted = false;
          this.model.active = "Sim";
          this.refreshData();
          this.hideModal();
          this.$forceUpdate;
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>